import { searchClient } from '@/lib/search/instantsearch/algoliaAdapter';
import { Suggestion } from './types';

/**
 * Query Algolia for sequence suggestions based on user input
 * Returns actual song titles, artist names, and genres from the index
 */
export async function getAlgoliaSequenceSuggestions(query: string): Promise<Suggestion[]> {
  if (!searchClient) {
    console.warn('Algolia client not available for autocomplete');
    return [];
  }

  if (!query || query.trim().length < 2) {
    // Return popular suggestions when query is empty or too short
    return [
      { label: 'xLights Sequences', value: 'xLights', type: 'software' },
      { label: 'Light-O-Rama Sequences', value: 'Light-O-Rama', type: 'software' },
      { label: 'Christmas Sequences', value: 'Christmas', type: 'holiday' },
      { label: 'Rock Sequences', value: 'Rock', type: 'genre' },
      { label: 'Pop Sequences', value: 'Pop', type: 'genre' },
    ];
  }

  try {
    // Query the sequences index
    const { results } = await searchClient.search([
      {
        indexName: 'sequences',
        query: query.trim(),
        params: {
          hitsPerPage: 8,
          attributesToRetrieve: ['title', 'artist_name', 'genres', 'software_type', 'image_url'],
          attributesToHighlight: [],
        },
      },
    ]);

    const hits = results[0]?.hits || [];
    const suggestions: Suggestion[] = [];

    // Debug: Log first hit to see what fields are available
    if (hits.length > 0) {
      console.log('First Algolia hit:', hits[0]);
      console.log('Album cover URL (image_url):', hits[0].image_url);
    }

    // Transform Algolia hits to suggestions
    hits.forEach((hit: any) => {
      // Add song title suggestion
      if (hit.title) {
        suggestions.push({
          label: hit.artist_name ? `${hit.title} - ${hit.artist_name}` : hit.title,
          value: hit.title,
          type: 'song',
          albumCoverUrl: hit.image_url,
          sequenceId: hit.objectID,
        });
      }
    });

    return suggestions.slice(0, 8); // Limit to 8 suggestions
  } catch (error) {
    console.error('Algolia autocomplete error:', error);
    return [];
  }
}
